import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { useTranslation } from 'react-i18next'
import useModal from '@/shared/hooks/useModal'
import { pageConfigurationActions } from '@/store/PageConfiguration/PageConfigurationSagas'
import {
  selectPageConfigurationData,
  selectPageConfigurationIsLoading,
} from '@/store/PageConfiguration/PageConfigurationSelectors'
import { updateSelectedAssistance } from './AssistanceSlice'
import { selectSelectedAssistance } from './AssistanceSelectors'

const useAssistance = () => {
  const dispatch = useDispatch()
  const { loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance, tinymceKey } = useSelector(selectAuthData)
  const { getApplicationUrl } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const initUrl = getApplicationUrl('assistance-management')
  const { t } = useTranslation()
  const { assistanceProducts } = useSelector(selectPageConfigurationData)
  const isLoading = useSelector(selectPageConfigurationIsLoading)
  const selectedAssistance = useSelector(selectSelectedAssistance)
  const { isOpen, close, setIsOpen } = useModal()
  const [page, setPage] = useState(1)
  const [assistanceSearch, setAssistanceSearch] = useState(assistanceProducts ?? [])

  const setAssistanceHandler = assistanceSearchList => {
    if (assistanceSearchList !== null) {
      setAssistanceSearch(assistanceSearchList)
    } else {
      setAssistanceSearch(assistanceProducts)
    }
  }

  const updateAssistanceSelected = assistance => {
    const attributes = assistance?.id ? assistance.attributes : {}
    const assistanceSelected = {
      id: assistance?.id ?? 0,
      name: assistance?.id ? assistance.name : '',
      price: assistance?.id ? attributes.price : '',
      description: assistance?.id ? attributes.description : '',
      know_more: assistance?.id ? attributes.know_more : '',
      status: assistance?.id ? attributes.status : '',
      zoho_id: assistance?.id ? assistance.zoho_id : '',
      zoho_prefix: assistance?.id ? assistance.potential_name : '',
    }

    dispatch(updateSelectedAssistance(assistanceSelected))
    setIsOpen(true)
  }

  useEffect(() => {
    dispatch({ type: pageConfigurationActions.INITIALIZE, initUrl })
  }, [])

  useEffect(() => {
    if (!assistanceProducts) return
    setAssistanceSearch(assistanceProducts)
  }, [assistanceProducts])

  return {
    t,
    assistanceProducts: assistanceSearch,
    isLoading,
    tinymceKey,
    elementsPerPage: 7,
    isOpen,
    close,
    page,
    setPage,
    setAssistanceHandler,
    updateAssistanceSelected,
    selectedAssistance,
  }
}

export default useAssistance
